import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

/** @deprecated  Exporting the component so that it can be used in other files. */
export default ExpansionPanelDetails;
